import { render, staticRenderFns } from "./EditTripConfig.vue?vue&type=template&id=0c998c78&"
import script from "./EditTripConfig.vue?vue&type=script&lang=js&"
export * from "./EditTripConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports